import { ConstructionSiteAnalysisData } from "@dune/types";
import { useMemo } from "react";

// Re-export the API hook
export { useGetConstructionSiteAnalysisData } from "../../../../api/queries/constructionSiteAnalysis.queries";

/**
 * Hook to get designer analysis data based on construction site characteristics
 * and declared designers - now using backend-calculated requirements
 *
 * @param constructionSiteData - The construction site data with all necessary information
 * @param declaredDesigners - Object indicating which designers have been declared (optional, as backend calculates this)
 * @returns Array of designer analysis data with requirements
 */
export function useConstructionSiteAnalysisData(
	constructionSiteData: ConstructionSiteAnalysisData,
) {
	return useMemo(() => {
		if (constructionSiteData.designerRequirements) {
			return constructionSiteData.designerRequirements.map((designer) => ({
				...designer,
				missions: Array.isArray(designer.missions)
					? designer.missions.join(", ")
					: designer.missions,
			}));
		}

		// Fallback to empty array if no backend data available
		// This should not happen in normal operation once backend is deployed
		console.warn(
			"No designer requirements calculated by backend, returning empty array",
		);
		return [];
	}, [constructionSiteData]);
}
